<template>
  <div class="metting-container">
    <div class="banner">
      <img
        src="https://scheme.timesmedia.com.cn/activity/metting/top_title@2x.png"
        class="banner-img-text"
      />
      <img src="https://scheme.timesmedia.com.cn/activity/metting/top_bg@2x.png" class="banner-img" />
    </div>
    <div class="main">
      <!-- 介绍 -->
      <div class="metting-summary">
        <span class="summary-title"></span>
        <p class="metting-content">“影响力·中国”时代峰会是广东时代传媒集团精心打造的系列高端峰会，汇聚学术界、思想界、产业界最具影响力的先驱者与决策者，权威解读最新经济政策和经济热点，共同探索中国经济新趋势，为持续提升中国经济实力与中国企业影响力建言献策。峰会迄今已成功举办九届，参会人数共4000余人，影响了众多企业家、金融家、经济学者和媒体人，建立了良好的品牌形象、美誉度及影响力。</p>
      </div>
      <!-- 主题 -->
      <div class="metting-theme">
        <span class="theme-title"></span>
        <p class="theme-tip">从春天出发，踏上高质量发展新征程</p>
        <p class="metting-content">从"经济新常态"到"新发展格局"，我们正踏上高质量发展新征程。<br/>2022年，中国经济迎难而进，产业链供应链总体稳固，科技创新成果丰硕，中国经济稳中向好、长期向好的基本面没有改变，转型升级、高质量发展的大势没有改变。2023年是全面贯彻落实党的二十大精神的开局之年，是实施“十四五”规划承前启后的关键一年，锚定高质量发展，着力构建新发展格局，是新时代中国经济发展的鲜明主题。<br/>在此背景下，本届峰会围绕中国宏观经济新逻辑、高质量发展新模式、经济改革发展新动能等社会热点议题展开讨论，深入研判。届时，我们将邀请知名经济学家，以及来自银行、基金、保险、上市公司、航空企业的高管出席盛会，一起聚焦高质量发展，探讨经济新动能，共同展望中国经济新未来，唱响“春天的故事”！</p>
      </div>
      <!-- 议程 -->
      <div class="metting-agenda">
        <img src="https://scheme.timesmedia.com.cn/activity/metting/agenda_01.png" />
        <img src="https://scheme.timesmedia.com.cn/activity/metting/agenda_02.png" />
        <img src="https://scheme.timesmedia.com.cn/activity/metting/agenda_03.png" />
        <!-- <span class="agenda-title"></span>
        <div style="padding-left: 230px">
          <div class="agenda-item">
            <p class="item-title">{{ agendaOptions.first.title }}</p>
          </div>
        </div> -->
        <!-- <div style="padding-left: 262px;margin-bottom: 100px;">
          <div class="agenda-item">
            <p class="item-title">{{ agendaOptions.first.title }}</p>
            <div>
              <div v-for="(v, i) in agendaOptions.first.times" :key="i" class="item-text">
                <span class="left">{{ v.time }}</span>
                <div class="right">
                  <span class="right-t">{{ v.title }}</span>
                  <p class="right-p">{{ v.tip }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;align-items: flex-start;">
          <div class="agenda-item">
            <p v-html="agendaOptions.second.title" class="item-title" />
            <div>
              <div v-for="(v, i) in agendaOptions.second.times" :key="i" class="item-text">
                <span class="left">{{ v.time }}</span>
                <div class="right">
                  <span class="right-t">{{ v.title }}</span>
                  <p class="right-p">{{ v.tip }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="agenda-item">
            <p v-html="agendaOptions.third.title" class="item-title"/>
            <div>
              <div v-for="(v, i) in agendaOptions.third.times" :key="i" class="item-text">
                <span class="left">{{ v.time }}</span>
                <div class="right">
                  <span class="right-t">{{ v.title }}</span>
                  <p class="right-p">{{ v.tip }}</p>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 嘉宾 -->
      <div class="metting-guests">
        <span class="guests-title"></span>
        <div class="guests-content-box">
          <div v-for="(v, i) in guestsList" :key="i" class="content-item">
            <p class="item-title">{{ v.name }}</p>
            <p class="item-summary">{{ v.summary }}</p>
          </div>
        </div>
      </div>
      <!-- 报道 -->
      <div v-if="info && info.information.arts.length" class="metting-report">
        <span class="report-title"></span>
        <div>
          <div @click="onLink(v.link)" v-for="(v, i) in info.information.arts" :key="i" class="report-item">
            <p class="left">{{ v.title }}</p>
            <div class="right">查看报道<i class="right-icon" /></div>
          </div>
        </div>
      </div>
      <!-- 组织 -->
      <div class="metting-organization">
        <span class="organization-title"></span>
        <div class="organization-content-box">
          <div v-for="(v, i) in organizationList" :key="i" :style="`width: ${v.width};`" class="content-item">
            <span class="item-title">{{ v.title }}</span>
            <p v-html="v.summary" class="item-summary" />
          </div>
        </div>
      </div>
      <!-- 赞助 -->
      <!-- <div class="metting-sponsor">
        <span class="sponsor-title"></span>
      </div> -->
      <!-- 支持 -->
      <div class="metting-supporter">
        <span class="supporter-title"></span>
        <img src="https://scheme.timesmedia.com.cn/activity/metting/supporter_logo@2x.png" />
      </div>
    </div>
    <div class="footer">
      <span class="footer-title"></span>
      <img src="https://scheme.timesmedia.com.cn/activity/metting/footer@2x.png" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agendaOptions: {
        first: {
          title: '主论坛',
          times: [
            {
              time: '08:00-08:30',
              title: '嘉宾签到'
            },
            {
              time: '08:30-09:00',
              title: '领导致辞'
            },
            {
              time: '09:00-09:20',
              title: '活动发布',
              tip: '第五届（中国）广州商务航空展开幕仪式中国商务机产业联盟成立仪式'
            },
            {
              time: '09:20-11:00',
              title: '主题演讲'
            },
            {
              time: '11:00-12:00',
              title: '参观商务航空展'
            },
          ]
        },
        second: {
          title: '分论坛一&nbsp;&nbsp;经济视野论坛',
          times: [
            {
              time: '14:00-14:05',
              title: '领导致辞'
            },
            {
              time: '14:05-15:45',
              title: '主题演讲'
            },
            {
              time: '15:45-16:30',
              title: '圆桌对话',
            },
          ]
        },
        third: {
          title: '分论坛二&nbsp;&nbsp;中国商务航空发展高峰论坛',
          times: [
            {
              time: '14:00-14:05',
              title: '领导致辞'
            },
            {
              time: '14:05-15:00',
              title: '主题演讲'
            },
            {
              time: '15:00-16:30',
              title: '圆桌对话',
            },
          ]
        }
      },
      guestsList: [
        {
          name: '姚景源',
          summary: '国务院参事室特约研究员、国家统计局原总经济师兼新闻发言人',
        },
        {
          name: '海闻',
          summary: '北京大学校务委员会副主任、北京大学原副校长、北大汇丰商学院创院院长',
        },
        {
          name: '贾康',
          summary: '华夏新供给经济学研究院院长、全国政协参政议政人才库特聘专家',
        },
        {
          name: '陈恒',
          summary: '广州空港经济区管理委员会副主任',
        },
        {
          name: '连平',
          summary: '中国首席经济学家论坛理事长、植信投资首席经济学家兼研究院院长',
        },
        {
          name: '姚余栋',
          summary: '大成基金副总经理兼首席经济学家',
        },
        {
          name: '林采宜',
          summary: '中国首席经济学家论坛研究院副院长',
        },
        {
          name: '邹功达',
          summary: '广州期货股份有限公司总经理',
        },
        {
          name: '黄海明',
          summary: '佳都集团副总裁，创新园区事业部总经理',
        },
        {
          name: '罗朝忠',
          summary: '中信银行广州分行私人银行部总经理',
        },
        {
          name: '黄震环',
          summary: '佛山照明董秘',
        },
        {
          name: '黄斌全',
          summary: '中大咨询集团研究院院长',
        },
        {
          name: '房鑫淼',
          summary: '广州基金董秘',
        },
        {
          name: '刘建',
          summary: '广发证券投行委员会执行董事、保荐代表人',
        },
        {
          name: '蒋飞',
          summary: '长城证券首席宏观分析师',
        },
        {
          name: '陶晓峰',
          summary: '美的金融平台运营总监',
        },
        {
          name: '綦琦',
          summary: '广州民航职业技术学院副教授',
        },
        {
          name: '林佩群',
          summary: '翼通商务航空董事长',
        },
        {
          name: '王卫',
          summary: 'BAA亚联公务机董事长',
        },
        {
          name: '李博锴',
          summary: 'BAA亚联公务机总裁',
        },
        {
          name: '王久',
          summary: '七彩云南通用航空总经理',
        },
        {
          name: '史建元',
          summary: '德事隆航空 中国战略与销售副总裁',
        },
        {
          name: '左利坤',
          summary: '宏信通用航空总经理',
        },
        {
          name: '曹扬',
          summary: '华南国际商务航空运行副总',
        },
        {
          name: '丁莉丽',
          summary: '中一航空商务部经理',
        },
        {
          name: '张强',
          summary: '亚洲商务航空总裁',
        },
        {
          name: '俞煜滨',
          summary: '金鹿公务航空总经理',
        },
        {
          name: '纪光',
          summary: '铂雅公务航空总裁',
        },
        {
          name: '王蕊',
          summary: '999急救中心航空医疗救援队负责人',
        },
        {
          name: '张传勇',
          summary: 'ASBAA中国区主席',
        },
        {
          name: '周丽媛',
          summary: '云领公务航空创始人',
        },
      ],
      organizationList: [
        {
          title: '主办单位',
          summary: '广东时代传媒集团有限公司\n广东翼通商务航空发展股份有限公司',
          width: '39.5%'
        },
        {
          title: '承办单位',
          summary: '时代周报\n时代财经APP',
          width: '28.5%'
        },
        {
          title: '主办单位',
          summary: '时代商学院&emsp;消费者报道&emsp;葡萄酒&emsp;&emsp;少年文摘\n新周刊&emsp;&emsp;&emsp;创业圈&emsp;&emsp;&emsp;收藏拍卖',
          width: '32%'
        },
      ],
      info: null,
    }
  },
  methods: {
    getTopicsInfo() {
      const forum_id = this.$route.query.forum_id || 12

      this.$api.topics.getTopicsInfo({ forum_id }).then((res) => {
        if (res.status === "success") {
          this.info = res.data;
        }
      });
    },
    onLink(link = null) {
      if (!link) {
        return;
      }

      window.open(link);
    },
  },
  created() {
    this.getTopicsInfo()
  }
}
</script>

<style>
  html, body {
    background: #EDF4FA;
  }
</style>
<style lang="scss" scoped>
  .metting-container {
    width: 100%;
    .banner {
      position: relative;
      width: 100%;
      font-size: 0;
      .banner-img-text {
        position: absolute;
        width: 62%;
        top: calc(100vw * 0.043);
        left: 0;
        right: 0;
        margin: auto;
        z-index: 1;
      }
      .banner-img {
        display: block;
      }
      img {
        display: block;
        width: 100%;
      }
    }
    .metting-content {
      font-size: 18px;
      color: #000000;
      line-height: 30px;
      text-align: justify;
    }
    .main {
      position: relative;
      width: 100%;
      max-width: 1200px;
      margin: auto;
      margin-top: calc(-100vw * 0.12);
      z-index: 1;
      .metting-summary {
        width: 100%;
        background: rgba(255,255,255,.2);
        box-sizing: 1px solid #fff;
        background-size: 100% 100%;
        padding: 32px 125px 40px;
        margin-bottom: 35px;
        box-sizing: border-box;
        .summary-title {
          display: block;
          width: 183px;
          height: 37px;
          margin: 0 auto 40px;
          background: url('https://scheme.timesmedia.com.cn/activity/metting/intro_title@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .metting-theme {
        width: 100%;
        background: url('https://scheme.timesmedia.com.cn/activity/metting/theme_bg@2x.png') no-repeat;
        background-size: 100% 100%;
        padding: 45px 125px 52px;
        .theme-title {
          display: block;
          width: 84px;
          height: 37px;
          margin: 0 auto 30px;
          background: url('https://scheme.timesmedia.com.cn/activity/metting/theme_title@2x.png') no-repeat;
          background-size: 100% 100%;
        }
        .theme-tip {
          font-size: 20px;
          font-weight: bold;
          color: #2167C6;
          line-height: 22px;
          margin-bottom: 27px;
          text-align: center;
        }
      }
      .metting-agenda {
        width: 100%;
        // padding: 46px 0 76px;
        // background: url('https://scheme.timesmedia.com.cn/activity/metting/agenda_bg@2x.png') no-repeat;
        // background-size: 100% 100%;
        // .agenda-title {
        //   display: block;
        //   width: 103px;
        //   height: 37px;
        //   margin: 0 auto 98px;
        //   background: url('https://scheme.timesmedia.com.cn/activity/metting/agenda_title@2x.png') no-repeat;
        //   background-size: 100% 100%;
        // }
        // .agenda-item {
        //   position: relative;
        //   .item-title {
        //     font-size: 20px;
        //     font-weight: bold;
        //     color: #FFFFFF;
        //     line-height: 22px;
        //     margin-bottom: 8px;
        //   }
        //   .item-text {
        //     display: flex;
        //     align-items: flex-start;
        //     &:not(:last-child) {
        //       margin-bottom: 19px;
        //     }
        //     .left {
        //       font-size: 18px;
        //       font-weight: 400;
        //       color: #D2E1FF;
        //       line-height: 18px;
        //       margin-top: 2px;
        //       margin-right: 22px;
        //     }
        //     .right {
        //       .right-t {
        //         font-size: 18px;
        //         font-weight: bold;
        //         color: #FFFFFF;
        //         font-size: 18px;
        //       }
        //       .right-p {
        //         max-width: 320px;
        //         font-size: 17px;
        //         color: #FFFFFF;
        //         margin-top: 9px;
        //         line-height: 22px;
        //       }
        //     }
        //   }
        // }
        > img {
          display: block;
          width: 100%;
        }
      }
      .metting-guests {
        width: 100%;
        padding: 60px 130px 40px;
        background: linear-gradient(2deg, rgba(255,255,255,0.21), rgba(255,255,255,0));
        box-shadow: 0px 30000px 250px 0px rgba(255,255,255,0.13), 0px 2px 8px 0px rgba(255,255,255,0.46);
        .guests-title {
          display: block;
          width: 102px;
          height: 37px;
          margin: 0 auto 90px;
          background: url('https://scheme.timesmedia.com.cn/activity/metting/guests_title@2x.png') no-repeat;
          background-size: 100% 100%;
        }
        .guests-content-box {
          display: flex;
          flex-wrap: wrap;
          .content-item {
            width: calc(100% / 5);
            padding-right: 20px;
            box-sizing: border-box;
            margin-bottom: 22px;
            .item-title {
              position: relative;
              padding-left: 10px;
              font-size: 16px;
              font-weight: bold;
              color: #003BD0;
              line-height: 16px;
              &::after {
                content: '';
                position: absolute;
                width: 4px;
                height: 100%;
                background: #003BD0;
                top: 0;
                left: 0;
                z-index: 1;
              }
            }
            .item-summary {
              min-height: 40px;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              white-space: pre-line;
              margin-top: 8px;
            }
          }
        }
      }
      .metting-report {
        width: 100%;
        padding: 40px 125px 98px;
        background: url('https://scheme.timesmedia.com.cn/activity/metting/report_bg@2x.png') no-repeat;
        background-size: 100% 100%;
        .report-title {
          display: block;
          width: 102px;
          height: 37px;
          margin: 0 auto 70px;
          background: url('https://scheme.timesmedia.com.cn/activity/metting/report_title@2x.png') no-repeat;
          background-size: 100% 100%;
        }
        .report-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 20px 26px 20px 14px;
          border: 1px solid #FFFFFF;
          box-sizing: border-box;
          user-select: none;
          cursor: pointer;
          &:not(:last-child) {
            margin-bottom: 50px;
          }
          .left {
            max-width: 600px;
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 22px;
          }
          .right {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 22px;
            .right-icon {
              margin-left: 8px;
              width: 14px;
              height: 14px;
              background: url('https://scheme.timesmedia.com.cn/activity/metting/report_icon_arrow_right@2x.png') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
      .metting-organization {
        padding: 55px 132px 118px;
        .organization-title {
          display: block;
          width: 188px;
          height: 37px;
          margin: 0 auto 60px;
          background: url('https://scheme.timesmedia.com.cn/activity/metting/organization_title@2x.png') no-repeat;
          background-size: 100% 100%;
        }
        .organization-content-box {
          display: flex;
          align-items: flex-start;
          .content-item {
            box-sizing: border-box;
            .item-title {
              display: inline-block;
              padding: 6px 12px;
              background: #3973C3;
              font-size: 16px;
              font-weight: bold;
              color: #F3F7FC;
              line-height: 22px;
              margin-bottom: 20px;
            }
            .item-summary {
              font-size: 14px;
              font-weight: 400;
              color: #000000;
              line-height: 22px;
              white-space: pre-line;
            }
          }
        }
      }
      .metting-sponsor {
        .sponsor-title {
          display: block;
          width: 119px;
          height: 37px;
          margin: 0 auto 180px;
          background: url('https://scheme.timesmedia.com.cn/activity/metting/sponsor_title@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .metting-supporter {
        padding-top: 60px;
        .supporter-title {
          display: block;
          width: 149px;
          height: 37px;
          margin: 0 auto 70px;
          background: url('https://scheme.timesmedia.com.cn/activity/metting/supporter_title@2x.png') no-repeat;
          background-size: 100% 100%;
        }
        >img {
          display: block;
          width: 940px;
          margin: auto;
        }
      }
    }
    .footer {
      padding-top: 113px;
      .footer-title {
        display: block;
        width: 178px;
        height: 37px;
        margin: 0 auto 40px;
        background: url('https://scheme.timesmedia.com.cn/activity/metting/cooperation_title@2x.png') no-repeat;
        background-size: 100% 100%;
      }
      > img {
        display: block;
        width: 100%;
        user-select: none;
      }
    }
  }
</style>
